import { Controller } from "@hotwired/stimulus";

let COLORS = 'ff0000 800000 a52a2a d2b48c ffa500 ffd700 00ff00 808000 008000 008080 0000ff 000080 8f00ff'.split(' ')
let boxStyle = 'width: 34px; height: 34px; border-radius: 5px; cursor: pointer; display: inline-block;'
let gridStyle = `
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 34px);
  grid-template-rows: repeat(auto-fill, 34px);
  gap: 7px;
`

export default class extends Controller {
  connect() {
    // this.element.type = 'color'
    let html = `
      <div style="${gridStyle}">
        <input
          type="color"
          id="colorPicker"
          oninput="$('#${this.element.id}').val(this.value).css('background-color', this.value)"
          style="${boxStyle};"
        />
        ${COLORS.map((color)=>this.box(color)).join("\n")}
      </div>
    `

    let value = this.element.value
    if (value) {
      this.element.style.backgroundColor = value
      this.element.style.color = '#fff'
      this.element.style.textShadow = '0 0 2px #000'
    }

    $(this.element).after(html)
  }

  box(color, style) {
    if (!color.includes('#')) {
      color = `#${color}`
    }
    return `
      <span
        style="${boxStyle}; background-color: ${color}; ${style || ''}"
        onclick="$('#tag_tag_color').val('${color}').css('background-color', '${color}')"
      >&nbsp;</span>`
  }

  set(c) {
    console.log(c)
  }
}
